export default "__VITE_ASSET__Dsmj7XsC__"